// ── Watchdog (device connectivity) types ──────────────────────────────────

/** Connectivity bucket for an active device, by age of its last communication. */
export type WatchdogStatus = 'ok' | 'offline1' | 'offline2' | 'offline3' | 'notActive';

/** One row in the Watchdog table — one active, provisioned device. */
export interface WatchdogRow {
  id: string;
  name: string;
  serialNumber: string;
  group: string;
  model: string;                 // device.deviceType, powers the "All Models" filter
  lastComm: Date | null;         // last communication time (DeviceStatusInfo.dateTime)
  offlineMs: number | null;      // now - lastComm at fetch time (null when never reported)
  status: WatchdogStatus;
  isCommunicating: boolean;      // DeviceStatusInfo.isDeviceCommunicating (live reachability hint)
}

export const WATCHDOG_STATUS_META: Record<
  WatchdogStatus,
  { label: string; shortLabel: string; colorVar: string }
> = {
  ok:        { label: 'OK (<24h)',    shortLabel: 'OK',          colorVar: 'var(--healthy)'  },
  offline1:  { label: 'Offline 1–2d', shortLabel: 'Offline 1–2d', colorVar: 'var(--accent)'   },
  offline2:  { label: 'Offline 2–3d', shortLabel: 'Offline 2–3d', colorVar: 'var(--warning)'  },
  offline3:  { label: 'Offline 3+d',  shortLabel: 'Offline 3+d',  colorVar: 'var(--critical)' },
  notActive: { label: 'Not Active',   shortLabel: 'Not Active',  colorVar: 'var(--muted)'    },
};
